// export const urlHeader = "http://localhost:8443/api/test/";
// export const authHeader = "http://localhost:8443/api/auth/";
export const urlHeader = "https://www.datamachine.info:443/workbench/api/test/";
export const authHeader = "https://www.datamachine.info:443/workbench/api/auth/";
// export const urlHeader = "http://10.0.0.159:8443/workbench/api/test/";
// export const authHeader = "http://10.0.0.159:8443/workbench/api/auth/";
// export const urlHeader = "http://10.0.0.160:8443/workbench/api/test/";
// export const authHeader = "http://10.0.0.160:8443/workbench/api/auth/";
// export const urlHeader = "https://mypermagarden.com:443/workbench/api/test/";
// export const authHeader = "https://mypermagarden.com:443/workbench/api/auth/";

